interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  className?: string;
  href?: string;
}

export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  onClick, 
  className = '',
  href 
}: ButtonProps) {
  const baseClasses = 'font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer inline-flex items-center justify-center';
  
  const variantClasses = {
    primary: 'bg-[#f28c1a] text-white hover:bg-[#e07a15]',
    secondary: 'bg-[#5a6ab0] text-white hover:bg-[#4a5a9f]',
    outline: 'border-2 border-[#f28c1a] text-[#f28c1a] hover:bg-[#f28c1a] hover:text-white'
  };

  const sizeClasses = {
    sm: 'px-4 py-2 text-sm rounded-md',
    md: 'px-6 py-3 text-base rounded-lg',
    lg: 'px-8 py-4 text-lg rounded-lg'
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  if (href) {
    return (
      <a href={href} className={classes}>
        {children}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={classes}>
      {children}
    </button>
  );
}